module.exports = __webpack_public_path__ + "static/computer-work-cae1da8f210535e1c0dbc09a4a42bfbd.jpg";